// extracted by mini-css-extract-plugin
export default {"container":"socialMedia_container__chRzi"};